<div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
  <div class="col">
    <div class="card h-100" [ngClass]="themeClass">
      <div class="">
        <h3 class="card-header" [ngClass]="themeClass">
          {{ 'TABLE.DETAILS.informations.maintenance_and_testing.title' | translate }}
        </h3>
        @if (maintenance$ | async; as maintenanceResult) {
          @if (maintenanceResult.failed) {
            <div class="card-text p-3">
              <span>{{ 'TABLE.DETAILS.informations.maintenance_and_testing.no_data' | translate }}</span>
            </div>
          } @else {
            @if (maintenanceResult.data; as maintenance) {
              <div class="card-text">
                <div class="card-entry">
                  <span class="fw-semibold"
                    >{{ 'TABLE.DETAILS.informations.maintenance_and_testing.testing_date' | translate }}:
                  </span>
                  @if (maintenance.installDate) {
                    <span>{{ maintenance.installDate | date: 'dd/MM/yyyy' }}</span>
                  } @else {
                    <span>{{ '-' }}</span>
                  }
                </div>
                <div class="card-entry">
                  <span class="fw-semibold"
                    >{{ 'TABLE.DETAILS.informations.maintenance_and_testing.last_maintenance_date' | translate }}:</span
                  >
                  @if (maintenance.lastMaintenance) {
                    <span>{{ maintenance.lastMaintenance | date: 'dd/MM/yyyy' }}</span>
                  } @else {
                    <span>{{ '-' }}</span>
                  }
                </div>
                <div class="card-entry">
                  <span class="fw-semibold"
                    >{{ 'TABLE.DETAILS.informations.maintenance_and_testing.maintenance_interventions' | translate }}:
                  </span>
                  @if (maintenance.remainingInterventions !== null) {
                    <span>{{ maintenance.remainingInterventions }}</span>
                  } @else {
                    <span>{{ '-' }}</span>
                  }
                </div>
                <div class="d-flex justify-content-end mt-3">
                  <button
                    class="renew-btn"
                    [routerLink]="['/request', 'new']"
                    [queryParams]="{
                      serialNumber: serialNumber,
                      reason: 'Richiesta di pianificazione intervento di manutenzione ordinaria'
                    }"
                    [ngClass]="themeClass"
                    *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'PARTNER', 'ADMIN']"
                  >
                    {{ 'TABLE.BUTTONS.machines.book_maintenance' | translate }}
                  </button>
                </div>
              </div>
            }
          }
        } @else {
          <div class="card-text d-flex justify-content-center align-items-center p-3">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="col">
    <div class="card h-100" [ngClass]="themeClass">
      <div class="">
        @if (contracts$ | async; as contractsResult) {
          @if (contractsResult.failed) {
            <div class="card-header fw-semibold" [ngClass]="themeClass">
              <h3 class="my-0 py-0">{{ 'TABLE.DETAILS.informations.warranty.title' | translate }}:</h3>
            </div>
            <div class="card-text p-3">
              <span>{{ 'TABLE.DETAILS.informations.warranty.no_data' | translate }}</span>
            </div>
          } @else {
            <div class="d-flex align-items-center card-header fw-semibold gap-3" [ngClass]="themeClass">
              <h3 class="my-0 py-0">{{ 'TABLE.DETAILS.informations.warranty.title' | translate }}:</h3>
              <div class="d-flex align-items-center gap-1">
                @if (warrantyContract?.state) {
                  <app-status-badge [status]="warrantyContract!.state!" />
                }
                <h3 class="my-0 py-0">
                  {{
                    'TABLE.DETAILS.informations.warranty.state.' +
                      (warrantyContract?.state ?? 'none') | translate
                  }}
                </h3>
              </div>
            </div>
            <p class="card-inner vertical-padding fw-semibold my-1">
              {{ 'TABLE.DETAILS.informations.warranty.warranty_fee' | translate }}
            </p>
            @if (warrantyContract) {
              <div class="card-inner">
                <div class="card-entry">
                  <span class="fw-semibold">{{ 'TABLE.DETAILS.informations.warranty.start_date' | translate }}</span>
                  @if (warrantyContract.startDate) {
                    <span> {{ warrantyContract.startDate | date: 'dd/MM/yyyy' }}</span>
                  } @else {
                    <span>-</span>
                  }
                </div>
                <div class="wrapper-end-date">
                  <div class="card-entry">
                    <span class="fw-semibold">{{ 'TABLE.DETAILS.informations.warranty.end_date' | translate }}</span>
                    @if (warrantyContract.endDate) {
                      <span>{{ warrantyContract.endDate | date: 'dd/MM/yyyy' }}</span>
                    } @else {
                      <span>-</span>
                    }
                  </div>
                  @if (warrantyContract.state === 'IN SCADENZA') {
                    <div>
                      <div class="d-flex align-items-center gap-2 expiration-status">
                        <app-icam-icon [iconName]="'warning'" [iconHeight]="'19px'" [isDefault]="true" />
                        <p class="m-0 p-0 text-icam-danger">
                          {{ 'TABLE.DETAILS.informations.warranty.state.expiring' | translate }}
                        </p>
                      </div>
                    </div>
                  }
                </div>
                @if (warrantyContract.state && warrantyContract.state !== 'VALIDO') {
                  <div>
                    <div class="d-flex justify-content-end mt-3">
                      <button
                        class="renew-btn"
                        [routerLink]="['/request', 'new']"
                        [queryParams]="{
                          serialNumber: serialNumber,
                          reason: 'Richiesta informazioni contratto manutenzione, assistenza remota',
                          description: warrantyContract.contractName
                        }"
                        [ngClass]="themeClass"
                        *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'PARTNER', 'ADMIN']"
                      >
                        {{ 'TABLE.BUTTONS.machines.renew' | translate }}
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          }
        } @else {
          <div class="card-header fw-semibold" [ngClass]="themeClass">
            <h3 class="my-0 py-0">{{ 'TABLE.DETAILS.informations.warranty.title' | translate }}:</h3>
          </div>
          <div class="card-text d-flex justify-content-center align-items-center p-3">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="col">
    <div class="card h-100" [ngClass]="themeClass">
      <div class="">
        <h3 class="card-header" [ngClass]="themeClass">
          {{ 'TABLE.DETAILS.informations.contracts.title' | translate }}
        </h3>
        @if (contracts$ | async; as contractsResult) {
          <div class="card-text">
            @if (contractsResult.failed) {
              <span>{{ 'TABLE.DETAILS.informations.contracts.no_data' | translate }}</span>
            } @else if (contractsResult.data!.length > 0) {
              <app-contracts-carousel [contracts]="contractsResult.data!" />
            } @else {
              <div class="d-flex justify-content-end">
                <span>{{ 'TABLE.DETAILS.informations.contracts.no_contracts' | translate }}</span>
              </div>
            }
          </div>
        } @else {
          <div class="card-text d-flex justify-content-center align-items-center p-3">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
